var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackType3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 69,
    viewBox: "0 0 130 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2054_34072)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.3604 115C61.1784 115 58.7236 114.728 55.9961 114.185C47.6317 112.012 41.2675 107.032 36.9034 99.2451C31.812 101.237 26.5388 101.69 21.0838 100.603C15.4469 99.3356 10.6283 96.4382 6.62789 91.9109C1.71834 86.2971 -0.463679 79.7779 0.0818256 72.3532C0.445496 64.7474 3.44577 58.4998 9.08266 53.6103C11.0828 51.9805 13.2649 50.0791 15.6287 47.906C17.8107 45.5518 20.1746 43.1976 22.7203 40.8434C27.0843 36.4973 31.6302 32.0605 36.3579 27.5333C41.2675 23.006 45.9952 19.022 50.541 15.5813C53.6322 13.2271 56.5416 11.1446 59.2691 9.33371C62.1785 7.5228 64.906 5.98353 67.4517 4.7159C76.9071 0.188636 86.1807 -1.079 95.2724 0.912998C105.637 3.81045 112.82 10.4202 116.82 20.7424C119.366 27.986 119.275 35.5918 116.547 43.5598C116.183 44.4652 115.82 45.3707 115.456 46.2762C115.092 47.1816 114.638 48.1776 114.092 49.2641C120.638 52.3427 125.366 57.4132 128.275 64.4757C130.821 71.7194 130.548 78.7819 127.457 85.6633C124.366 92.3637 119.184 96.9815 111.91 99.5167C106.273 101.69 101.091 103.682 96.3635 105.493C91.6358 107.123 87.6354 108.481 84.3623 109.567C82.544 110.292 80.8166 110.925 79.1801 111.469C77.7254 112.012 76.5434 112.465 75.6343 112.827C73.8159 113.189 71.9066 113.642 69.9065 114.185C67.9063 114.728 65.7243 115 63.3604 115Z",
    fill: "#CEFDE3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2054_34072"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 69,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackType3);
export default __webpack_public_path__ + "static/media/back_type3.7211e4a94b50a7fa78f0943a68ed90d2.svg";
export { ForwardRef as ReactComponent };